import React, { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { OnClickFunctionType } from '@/types/common-dom/types';

interface IconWithFloatingContentProps {
  icon: React.ReactElement;
  floatingContent?: ReactNode;
  onClick?: OnClickFunctionType;
  className?: string;
  wrapperClassName?: string;
  counterNode?: ReactNode;
  dataTestId?: string;
}

const IconWithFloatingContent: React.FC<IconWithFloatingContentProps> = ({
  icon,
  floatingContent,
  onClick,
  className = '',
  wrapperClassName = '',
  counterNode,
  dataTestId
}) => {
  return (
    <div className={twMerge('relative inline-block', wrapperClassName)} onClick={onClick} data-testid={dataTestId}>
      <button
        data-testid={`${dataTestId}-btn`}
        className={twMerge(
          `flex p-100 bg-transparent rounded-full active:bg-surface-300-bg focus:outline-none`,
          className
        )}>
        {icon}
      </button>
      {floatingContent && (
        <div className="absolute -top-1 -right-1 transform translate-x-1/2 -translate-y-1/2">{floatingContent}</div>
      )}
      {!!counterNode ? counterNode : null}
    </div>
  );
};

export default IconWithFloatingContent;
